import { render, staticRenderFns } from "./CoButton.vue?vue&type=template&id=cff8ad4a&scoped=true&"
import script from "./CoButton.vue?vue&type=script&lang=ts&"
export * from "./CoButton.vue?vue&type=script&lang=ts&"
import style0 from "./CoButton.vue?vue&type=style&index=0&id=cff8ad4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff8ad4a",
  null
  
)

export default component.exports